exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-block[data-v-6a6d8e95]{margin-top:20px}.sidebar-block .inline-value[data-v-6a6d8e95]{display:-ms-inline-flexbox;display:inline-flex}.sidebar-block[data-v-6a6d8e95]:first-child{margin-top:0}.sidebar-block__title[data-v-6a6d8e95]{font-weight:700}.sidebar-block__center[data-v-6a6d8e95]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a6d8e95","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/sidebar/components/SidebarElement.vue
// module id = c70ed3d1bf5787b089f1
// module chunks = 0